module.exports = new __parcel__URL__("neon-phrases.f34a4785.jpg").toString();